export const RESET_PASSWORD_SUCCESS_PAGE_TITLE = 'Password Set!';

export const RESET_PASSWORD_SUCCESS_PAGE_ADDITIONAL_TEXT =
  'You have succesfully set your new password, Please click the button below to sign into your account. Be sure to use your new password';

export const RESET_PASSWORD_SUCCESS_SUBMIT_BUTTON = 'Continue';
